import { FilterPublishStatus } from '../../graphql/gen/types';
import { useFiltersState } from './useFiltersState';

export function usePublishStatusFilter(): FilterPublishStatus {
  const [filtersState] = useFiltersState();

  return filtersState.publishStatusFilter;
}
